import {createTheme} from '@material-ui/core/styles';

const getColorMain = () => {
  switch (Config.base.uiColor) {
    case 'green':
      return '#126e60';
    case 'yellow':
      return '#bd8a09';
    case 'red':
      return '#cc3148';
    default:
      return '#6251DA';
  }
};

export default createTheme({
  palette: {
    primary: {
      main: getColorMain(),
    },
    secondary: {
      main: '#1f9eb4',
    },
  },
});
